import React, { Component } from 'react';
import axios from '../../axios';
import qs from 'qs';
import Alert from 'react-s-alert'
import FormDropdown from '../../components/FormDropdown'
import { status_aktif } from '../../constants/general'
import Dropzone from 'react-dropzone'
import { MEDIA_HOST } from '../../constants/siteConfig'
import Select from "react-select";
import DropdownView from "../Materi/DropdownViewB";
import moment from "moment";

class Forms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            materi_id           : "",
            materi_judul        : "",
            materi_status       : "",
            kelas_id            : "",
            mapel_id            : "",
            user_id             : "",
            materi_file_exist   : "",
            kelasNew            :"",
            materi_file         : "",
            materi_tipe         : "",
            dataMapel           : [],
            dataGuru            : [],
            dataKelas           : [],
            isdataLoaded        : false,
            isButtonLoading     : false,
            isLoadingDataKelas: false,
            isLoading           : false,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeTipe = this.handleChangeTipe.bind(this);
        this.handleChangeMultiSelect = this.handleChangeMultiSelect.bind(this);
    }

    handleChangeTipe(event) {
        const target = event.target;
        const value  = target.value;
        const name   = target.name;
        if (value == 'drive') {
            this.setState({
                materi_tipe:"drive"
            })
        }
        if (value !== 'drive') {
            this.setState({
                materi_tipe:"file"
            })
        }
        this.setState({
            [name]: value
        })
    }

    handleChangeMultiSelect(stateName, text) {
        this.setState({[stateName]: text});

        if (stateName == 'participants') {
            let kelas = [];
            for (var i = 0; i < text.length; i++) {
                kelas.push(text[i].value);
            }

            const kelasNew = kelas.join(',');

            this.setState({
                kelasNew
            });
        }

    }

    handleChange(event) {

        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    handleSubmit() {
        let formData = new FormData();

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        formData.append("code", localStorage.SECOLAH_CODE);
        formData.append('materi_id', this.state.materi_id)
        formData.append('kelas_id', this.state.kelasNew)
        formData.append('mapel_id', this.state.mapel_id)
        formData.append('user_id', this.state.user_id)
        formData.append('materi_judul', this.state.materi_judul)
        formData.append('materi_status', this.state.materi_status)
        formData.append('materi_file', this.state.materi_file)
        formData.append('materi_tipe', this.state.materi_tipe)

        const url = this.props.mode === "Tambah" ? "materi/add" : "materi/edit"

        this.setState({ isButtonLoading: true })

        axios.post(url, formData, config)
            .then(response => {

                const result = response.data;

                if (result.success) {

                    Alert.success(result.message)
                    this.props.history.replace("/materi")
                }
                else {

                    if (Array.isArray(result.message)) {

                        result.message.map(item => {
                            Alert.error(item)

                            return true
                        })
                    }
                    else {

                        Alert.error(result.message)
                    }

                    this.setState({ isButtonLoading: false })
                }
            })
            .catch(error => {

                console.log("ERROR", error)
                Alert.error("Gagal terhubung ke server!")
                this.setState({ isButtonLoading: false })
            })
    }

    handleDeleteFile() {

        this.setState({
            materi_file: ""
        })
    }

    onDrop(files) {

        this.setState({
            materi_file: files[0]
        });
    }

    loadData() {

        if (this.props.mode === "Edit") {

            this.setState({ isLoading: true, isdataLoaded: false })

            axios({
                method: 'get',
                url: '/materi/' + this.props.match.params.materi_id
            })
                .then(response => {

                    const result = response.data

                    if (result.success) {

                        this.setState({
                            materi_id         : result.data.materi_id,
                            materi_judul      : result.data.materi_judul,
                            materi_status     : result.data.materi_status,
                            mapel_id          : result.data.mapel_id,
                            user_id           : result.data.user_id,
                            materi_file         : result.data.materi_file,
                            materi_file_exist : result.data.materi_file,
                            materi_tipe           : result.data.materi_tipe,
                            kelas_id          : result.data.kelas_id.split(","),
                            isLoading         : false,
                            isdataLoaded      : true
                        })

                        var data_kelas_id = []

                        for (var i=0; i<this.state.kelas_id.length; i++) {
                            var arr_kelas_id =[]
                            arr_kelas_id["kelas_id"]= this.state.kelas_id[i]
                            data_kelas_id[i] = arr_kelas_id
                        }

                        const participants = data_kelas_id.map(
                            item => item.kelas_id
                        );


                        //
                        // newState.participants = participants.join(",");
                        // newState.kelasNew = kelasNew

                        this.setState(
                            {
                                kelasNew: participants.join(","),
                                participants: participants.join(",")
                            }
                        );


                    }
                    else {

                        Alert.error(result.message)
                        this.setState({ isLoading: false, isdataLoaded: false })
                    }

                })
                .catch((error) => {

                    console.log(error)
                    Alert.error("Gagal terhubung ke server!")
                    this.setState({ isLoading: false, isdataLoaded: false })
                })
        }

    }

    loadDataKelas() {
        this.setState({isLoadingDataKelas: true});

        const params = qs.stringify({
            locale: "id",
            platform: "web"
        })
        axios({
            method: 'post',
            url: '/kelas'
        })

            .then(response => {
                const result = response.data;
                if (result.success) {
                    const dataKelas = result.data.map(item => ({
                        value: item.kelas_id,
                        label: item.kelas_nama
                    }));

                    this.setState({
                        dataKelas,
                        isLoadingDataKelas: false
                    });
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }

                    this.setState({isLoadingDataKelas: false});
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({isLoadingDataKelas: false});
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataGuru() {

        const params = qs.stringify({
            level: "guru"
        })

        axios.post("/user?" + params)
            .then(response => {

                return response.data.data.map(item => ({
                    key: item.user_id,
                    value: item.user_nama
                }))
            })
            .then(result => {

                this.setState({
                    dataGuru: result
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    loadDataMapel() {

        axios.post("/mapel")
            .then(response => {

                return response.data.mapelexport.map(item => ({
                    key: item.mapel_id,
                    value: item.mapel_nama
                }))
            })
            .then(result => {

                this.setState({
                    dataMapel: result
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    componentDidMount() {

        this.loadData()
        this.loadDataKelas()
        this.loadDataMapel()
        this.loadDataGuru()
    }

    render() {

        return (
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">
                        {this.props.mode} Data Materi
                    </div>
                    <div className="card-block">
                        {
                            this.state.isLoading ? 'Memuat Data...' :
                                this.props.mode === "Edit" && ! this.state.isdataLoaded ?
                                    <div>Data gagal dimuat... <button className="btn-link" onClick={() => this.loadData()}><i className="fa fa-refresh"></i> Muat Ulang</button></div> : (
                                        <div className="form-horizontal animated fadeIn">
                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">Kelas</label>
                                                <div className="col-md-10">
                                                    <Select
                                                        multi
                                                        value={this.state.participants}
                                                        onChange={text =>
                                                            this.handleChangeMultiSelect("participants", text)
                                                        }
                                                        options={this.state.dataKelas}
                                                        placeholder="Kelas yang mengikuti"
                                                        removeSelected={this.state.removeSelected}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">Mata Pelajaran</label>
                                                <div className="col-md-10">
                                                    <FormDropdown
                                                        items={this.state.dataMapel}
                                                        onChange={this.handleChange}
                                                        value={this.state.mapel_id.toString()}
                                                        name="mapel_id"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">Guru</label>
                                                <div className="col-md-10">
                                                    <FormDropdown
                                                        items={this.state.dataGuru}
                                                        onChange={this.handleChange}
                                                        value={this.state.user_id}
                                                        name="user_id"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">Judul Materi</label>
                                                <div className="col-md-10">
                                                    <input
                                                        name="materi_judul"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Nama Judul Materi"
                                                        onChange={this.handleChange}
                                                        value={this.state.materi_judul} />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-md-2 form-control-label">Status Aktif</label>
                                                <div className="col-md-10">
                                                    <FormDropdown
                                                        items={status_aktif}
                                                        onChange={this.handleChange}
                                                        value={this.state.materi_status}
                                                        name="materi_status"
                                                    />
                                                </div>
                                            </div>
                                            <br></br>
                                            {  this.props.mode === "Edit" ? (
                                                <div className="">
                                                    <DropdownView
                                                        handleChange={this.handleChangeTipe}
                                                        stateName="status"
                                                        disabled="disabled"
                                                        label="Jenis Materi"
                                                        items={[
                                                            { key: "drive", value: "Drive" },
                                                            { key: "file", value: "File" },
                                                            { key: "xls", value: "File" },
                                                            { key: "xlsx", value: "File" },
                                                            { key: "doc", value: "File" },
                                                            { key: "docx", value: "File" },
                                                            { key: "pdf", value: "File" },
                                                        ]}
                                                        value={this.state.materi_tipe}
                                                    />


                                                    {this.state.materi_tipe === 'drive'?(
                                                        <div className="form-group row">
                                                            <label className="col-md-2 form-control-label">Url Materi Drive</label>
                                                            <div className="col-md-10">
                                                                <input
                                                                    name="materi_file"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Nama Judul Materi"
                                                                    onChange={this.handleChange}
                                                                    value={this.state.materi_file} />
                                                            </div>
                                                        </div>
                                                    ):(
                                                        this.state.materi_tipe !=='' && this.state.materi_tipe !=='drive'?(

                                                            <div className="form-group row">
                                                                <label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File Materi</label>
                                                                <div className="col-md-12">

                                                                    <Dropzone
                                                                        onDrop={this.onDrop.bind(this)}
                                                                        multiple={false}
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "auto",
                                                                            border: "2px dashed #e9e9e9",
                                                                            padding: "20px 30px",
                                                                            color: "#888",
                                                                            cursor: "pointer",
                                                                            textAlign: "center",
                                                                            marginBottom: "15px"
                                                                        }}
                                                                    >
                                                                        Klik atau drop file disini untuk mengupload file
                                                                    </Dropzone>

                                                                    {
                                                                        this.state.materi_file !== "" &&
                                                                        <span>
                                                            {this.state.materi_file.name} {" "}
                                                                            <button
                                                                                title="Hapus"
                                                                                className="btn btn-sm btn-danger"
                                                                                onClick={() => this.handleDeleteFile()}
                                                                                type="button"
                                                                            >
                                                                <i className="fa fa-remove"></i>
                                                            </button>
                                                        </span>
                                                                    }
                                                                    <br></br>
                                                                    <label>Note :</label><br></br>
                                                                    <label>File Upload Hanya bisa doc, docx, pdf, PDF, xls, xlsx</label><br></br>
                                                                    <label>Size file maksimal 2MB</label>
                                                                </div>
                                                            </div>


                                                        ) : ""
                                                    )}
                                                </div>
                                            ):(
                                                <div className="">
                                                    <DropdownView
                                                        handleChange={this.handleChangeTipe}
                                                        stateName="status"
                                                        label="Jenis Materi"
                                                        items={[
                                                            { key: "drive", value: "Drive" },
                                                            { key: "file", value: "File" }
                                                        ]}
                                                        value={this.state.materi_tipe}
                                                    />


                                                    {this.state.materi_tipe === 'drive'?(
                                                        <div className="form-group row">
                                                            <label className="col-md-2 form-control-label">Url Materi Drive</label>
                                                            <div className="col-md-10">
                                                                <input
                                                                    name="materi_file"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Nama Judul Materi"
                                                                    onChange={this.handleChange}
                                                                    value={this.state.materi_file} />
                                                            </div>
                                                        </div>
                                                    ):(
                                                        this.state.materi_tipe !=='' && this.state.materi_tipe !=='drive'?(

                                                            <div className="form-group row">
                                                                <label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File Materi</label>
                                                                <div className="col-md-12">

                                                                    <Dropzone
                                                                        onDrop={this.onDrop.bind(this)}
                                                                        multiple={false}
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "auto",
                                                                            border: "2px dashed #e9e9e9",
                                                                            padding: "20px 30px",
                                                                            color: "#888",
                                                                            cursor: "pointer",
                                                                            textAlign: "center",
                                                                            marginBottom: "15px"
                                                                        }}
                                                                    >
                                                                        <div>Klik atau drop file disini untuk mengupload file <br/>
                                                                            (.doc .docx .xls .xlsx .ppt .pptx .pdf .jpg dan maksimal 2MB)</div>
                                                                    </Dropzone>

                                                                    {
                                                                        this.state.materi_file !== "" &&
                                                                        <span>
                                                            {this.state.materi_file.name} {" "}
                                                                            <button
                                                                                title="Hapus"
                                                                                className="btn btn-sm btn-danger"
                                                                                onClick={() => this.handleDeleteFile()}
                                                                                type="button"
                                                                            >
                                                                <i className="fa fa-remove"></i>
                                                            </button>
                                                        </span>
                                                                    }
                                                                    <br></br>
                                                                    <label className="col-md-12 form-control-label">
                                                                        <strong>*Format yang di dukung :  .doc .docx .xls .xlsx .ppt .pptx .pdf .jpg .jpeg .png</strong><br/>
                                                                        <strong>*Maksimal ukuran file 2MB</strong><br/>
                                                                    </label>
                                                                </div>
                                                            </div>


                                                        ) : ""
                                                    )}
                                                </div>
                                            )}


                                            {
                                                this.props.mode === "Edit" && (

                                                    <div className="form-group row">
                                                        <label className="col-md-2 form-control-label">File/Url Materi
                                                            Sekarang</label>
                                                        <div className="col-md-10">
                                                            {
                                                                <span>
                                                                <a href={MEDIA_HOST + this.state.materi_file_exist}
                                                                   target="_blank" rel="noopener noreferrer">
                                                                    {this.state.materi_file_exist}
                                                                </a>
                                                            </span>
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            }


                                        </div>
                                    )
                        }
                    </div>
                    <div className="card-footer">
                        <button
                            type="button"
                            className="btn btn-md btn-primary"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={this.handleSubmit}
                        >
                            {this.state.isButtonLoading ? "Loading" : "Simpan"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Forms;


// WEBPACK FOOTER //
// ./src/views/Materi/Forms.js